import TypeWriter from './TypeWriter';

/**
 * ScrollTypeWriter - One-time typewriter for section headings
 * Triggers on scroll into viewport, types once, no looping.
 * 
 * segments: array of { text: string, cls: string }
 * e.g. [{ text: 'About ', cls: '' }, { text: 'CAD Drafting', cls: 'text-secondary italic' }]
 */
const ScrollTypeWriter = ({ segments, speed = 35 }) => (
  <TypeWriter texts={[segments]} speed={speed} loop={false} />
);

export default ScrollTypeWriter;
